import {
  notificationTypeMap,
  headerNotificationTabs as tabs,
} from "../../helpers/constants";
import { fetchAllNotifications } from "../../helpers/querycalls";
import { NotificationItem } from "./NotificationItem";
import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";

export const Notifications = () => {
  const [selectedNotificationTab, setSelectedNotificationTab] =
    useState("الكل");

  const { data, isLoading, error } = useQuery({
    queryKey: ["allNotifications"],
    queryFn: fetchAllNotifications,
    staleTime: 30 * 1000, //15 seconds
    refetchInterval: 30000, // Forces auto-refetch every 15s
  });
  const notifications = data?.notifications || [];
  const report = data?.reports || [];

  const counts = data?.counts || {
    allCount: 0,
    replyCount: 0,
    mentionCount: 0,
    reactionCount: 0,
  };

  // Filter notifications based on selected tab (No extra API calls)
  const filteredNotifications =
    selectedNotificationTab === "الكل"
      ? notifications
      : selectedNotificationTab === "ردود"
      ? notifications.filter((n) => n.notification_type === 2)
      : selectedNotificationTab === "إعجابات وتفاعل"
      ? notifications.filter((n) => n.notification_type === 25)
      : selectedNotificationTab === "منشن"
      ? notifications.filter((n) => n.notification_type === 1)
      : [];

  // Handle tab change
  const handleTabChange = (tabName) => {
    setSelectedNotificationTab(tabName);
  };

  if (isLoading)
    return (
      <div className="flex items-center justify-center h-screen w-full">
        <img
          loading="eager"
          src="/images/salla_loader_big.svg"
          alt="Loading..."
          className="w-16 h-16 loader"
        />
      </div>
    );
  if (error) return <div>Error loading notifications</div>;

  return (
    <div className="flex justify-center items-center sm:w-full">
      <div className="flex flex-col sm:mt-[6rem] sm:mr-[11rem] h-full w-full gap-[1rem] items-center pt-[50px] px-[16px]">
        <div className="w-full flex justify-end pl-4">
          <div>
            <span className="text-[#004D5A] text-[30px] font-bold">
              كل التنبيهات
            </span>
          </div>
        </div>
        {/* Tabs Container */}
        <div className="w-full flex justify-end">
          {tabs.map((tab, index) => (
            <div
              key={index}
              className={`${
                selectedNotificationTab === tab.tab_name ? "bg-[#BAF3E6]" : ""
              } px-2 py-1 sm:px-3 sm:py-2 cursor-pointer`}
              onClick={() => handleTabChange(tab.tab_name)}
            >
              <span
                className={`${
                  selectedNotificationTab === tab.tab_name
                    ? "text-[#004D5A]"
                    : "text-[#666666]"
                } flex gap-1 text-[12px] sm:text-[14px] font-medium`}
              >
                {tab.tab_name === "الكل" &&
                  (counts.allCount || 0) + (report?.length || 0)}
                {tab.tab_name === "ردود" && counts.replyCount}
                {tab.tab_name === "إعجابات وتفاعل" && counts.reactionCount}
                {tab.tab_name === "منشن" && counts.mentionCount}
                <p>{tab.tab_name}</p>
              </span>
            </div>
          ))}
        </div>
        <div
          className="flex flex-col justify-start custom-scrollbar w-full scroll-ms-4"
          dir="rtl"
        >
          {filteredNotifications.map((notification, index) => (
            <React.Fragment key={index}>
              <NotificationItem
                notification={notification}
                notificationTypeMap={notificationTypeMap}
                report={report}
              />
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};
